var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('default-template', [_c('div', {
    staticClass: "main-contents"
  }, [!_vm.$vuetify.breakpoint.mobile ? _c('slide-banner', {
    staticClass: "main-pc",
    attrs: {
      "code": "main-pc",
      "hide-pagination": ""
    }
  }) : _c('slide-banner', {
    staticClass: "main-mo",
    attrs: {
      "code": "main-mo",
      "hide-pagination": ""
    }
  }), _c('v-responsive', {
    staticClass: "overflow-visible",
    attrs: {
      "slot": "gshop-section",
      "width": "100%",
      "min-height": "100%"
    },
    slot: "gshop-section"
  }, [_c('v-responsive', {
    staticClass: "main-section main-section--product mx-auto",
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "width": "100%",
      "max-width": "1230"
    }
  }, [_c('main-giftcard', {
    attrs: {
      "filter": {
        'category-code': 'book'
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold main-category--title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("도서상품권")])]), _c('main-giftcard', {
    staticClass: "mt-8 mt-lg-16",
    attrs: {
      "filter": {
        'category-code': 'cultureland'
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold main-category--title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("컬쳐랜드")])]), _c('main-giftcard', {
    staticClass: "mt-8 mt-lg-16",
    attrs: {
      "filter": {
        'category-code': 'afreecatv'
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold main-category--title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("아프리카TV 별풍선")])]), _c('main-giftcard', {
    staticClass: "mt-8 mt-lg-16",
    attrs: {
      "filter": {
        'category-code': 'google-giftcard'
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold main-category--title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("구글 기프트카드")])])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }